import React from 'react'
import { Box, Flex, Loading, Message, Text } from '@workwhile/ui'
import {
  CompumaticCompanyLocationCell,
  CompumaticPunchCell,
  CompumaticShiftCell,
  CompumaticStatusCell,
} from '../../CompumaticPunchCells'
import { useRelatedCompumaticPunchesContextValue } from '../context/RelatedCompumaticPunchesProvider'

export const RelatedCompumaticPunchesMain = () => {
  const {
    state: { items, isLoading, isError, errorMessage },
  } = useRelatedCompumaticPunchesContextValue()

  if (isLoading) {
    return (
      <Box py={2}>
        <Loading />
      </Box>
    )
  }

  if (isError && errorMessage) {
    return (
      <Message variant="error" m={0}>
        {errorMessage}
      </Message>
    )
  }

  if (items.length === 0) {
    return (
      <Text fontSize={0} color="lightText" py={2}>
        No punches for this worker yesterday or today.
      </Text>
    )
  }

  return (
    <Box py={2} pl={4}>
      <Text fontSize={0} fontWeight={600} mb={2} color="lightText">
        Recent punches for this worker (yesterday and today)
      </Text>
      <Flex flexDirection="column" gap={2}>
        {items.map((punch) => (
          <Flex
            key={punch.id}
            gap={3}
            flexWrap="wrap"
            fontSize={0}
            alignItems="flex-start"
          >
            <Box minWidth="200px" flex="1 1 200px">
              <CompumaticCompanyLocationCell punch={punch} />
            </Box>
            <Box minWidth="180px" flex="1 1 180px">
              <CompumaticPunchCell punch={punch} compact />
            </Box>
            <Box minWidth="120px" flex="0 1 120px">
              <CompumaticStatusCell punch={punch} />
            </Box>
            <Box minWidth="200px" flex="1 1 200px">
              <CompumaticShiftCell punch={punch} />
            </Box>
          </Flex>
        ))}
      </Flex>
    </Box>
  )
}
